import { colors } from '../../colors';
var location = {
  bgColor: colors.softPink,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.pureBlack,
  cardRadius: '20px',
  backgroundWave: true
};
export default location;